// Entry point for the build script in your package.json
import "./src/jquery"
import "./src/jquery.easing"
import "./src/jquery.scrollto"

// Import @rails/ujs and start it
import Rails from "@rails/ujs"
Rails.start()

// Import Fancybox and expose it globally
import { Fancybox } from "@fancyapps/ui"
window.Fancybox = Fancybox

// Import fancybox and expose globally
//import "./src/fancybox"
// The UMD module attaches Fancybox to window.window, so we need to fix it

import "./src/scripts"
